import { APP_INITIALIZER, ModuleWithProviders, NgModule } from '@angular/core';
import {
  ConsoleLogger,
  CultureInfoProvider,
  EmptyLocalizationProvider,
  EmptyLogger,
  EventAggregator,
  ICultureInfoProvider,
  IEventAggregator,
  ILocalizationProvider,
  ILogger,
  LocalizationManager,
  MapLocalizationProvider
} from '@mosaik/core';
import {
  ApplicationService,
  FileService,
  IApplicationService,
  IMediaQueryService,
  MediaQueryService
} from '@mosaik/presentation';
import { HostService } from '../../Services/HostService';
import { COMMON_MODULE_CONFIG } from './CommonModuleTokens';
import { ICommonModuleConfig } from './ICommonModuleConfig';

/**
 * @internal
 * @factory
 */
export function loggerFacgtory(config?: ICommonModuleConfig): ILogger {
  if (config && config.logging && config.logging.provider) {
    const isDebugEnabled = config.logging.provider.isDebugEnabled ? config.logging.provider.isDebugEnabled : false;
    return config.logging.provider.type ? new config.logging.provider.type(isDebugEnabled) : new EmptyLogger();
  } else {
    return new EmptyLogger();
  }
}

/**
 * @internal
 * @factory
 */
export function localizationProviderFactory(config?: ICommonModuleConfig): ILocalizationProvider {
  if (config && config.localization && config.localization.provider) {
    let args = undefined;
    if (config.localization.provider.args) {
      args = config.localization.provider.args || undefined;
    }
    return config.localization.provider.type ? new config.localization.provider.type(args) : new EmptyLocalizationProvider();
  } else {
    return new EmptyLocalizationProvider();
  }
}

/**
 * @internal
 * @factory
 */
export function cultureInfoProviderFactory(config?: ICommonModuleConfig): ICultureInfoProvider {
  if (config && config.localization && config.localization.culture && config.localization.culture.provider) {
    const culture = config.localization.culture.provider.culture ? config.localization.culture.provider.culture : undefined;
    return config.localization.culture.provider.type
      ? new config.localization.culture.provider.type(culture)
      : new CultureInfoProvider(culture);
  } else {
    return new CultureInfoProvider();
  }
}

/**
 * @internal
 * @factory
 */
export function mediaQueryServiceFactory(eventAggregator: IEventAggregator): IMediaQueryService {
  const mediaQueryService = new MediaQueryService(eventAggregator);
  mediaQueryService.initialize();
  return mediaQueryService;
}

/**
 * @hidden
 * @internal
 */
export function applicationServiceInitializerFactory(applicationService: IApplicationService): Function {
  const fn = function (): void {
    applicationService.register(window).initialize();
  };
  return fn;
}

/**
 * @public
 */
@NgModule({
  providers: [
    { provide: EventAggregator, useClass: EventAggregator },
    { provide: ApplicationService, useClass: ApplicationService, deps: [EventAggregator] },
    { provide: ConsoleLogger, useFactory: loggerFacgtory, deps: [] },
    { provide: MediaQueryService, useFactory: mediaQueryServiceFactory, deps: [ApplicationService, EventAggregator] },
    { provide: CultureInfoProvider, useFactory: cultureInfoProviderFactory, deps: [] },
    /** #todo do not use MapLocalizationProvider here */
    { provide: MapLocalizationProvider, useFactory: localizationProviderFactory, deps: [] },
    { provide: LocalizationManager, useClass: LocalizationManager, deps: [MapLocalizationProvider, CultureInfoProvider] },
    { provide: FileService, useClass: FileService, deps: [ApplicationService] },
    { provide: HostService, useClass: HostService },
    { provide: APP_INITIALIZER, useFactory: applicationServiceInitializerFactory, deps: [ApplicationService], multi: true }
  ]
})
export class CommonModule {
  public static forRoot(config?: Partial<ICommonModuleConfig>): ModuleWithProviders<CommonModule> {
    return {
      ngModule: CommonModule,
      providers: [
        { provide: COMMON_MODULE_CONFIG, useValue: config },
        { provide: ConsoleLogger, useFactory: loggerFacgtory, deps: [COMMON_MODULE_CONFIG] },
        { provide: CultureInfoProvider, useFactory: cultureInfoProviderFactory, deps: [COMMON_MODULE_CONFIG] },
        /** #todo do not use MapLocalizationProvider here */
        { provide: MapLocalizationProvider, useFactory: localizationProviderFactory, deps: [COMMON_MODULE_CONFIG] }
      ]
    };
  }
}
